import Model from '../utils/Model'

export default class BillType {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'BillType'
export const NORMAL_BILL_TYPE = new BillType(1, 'Normal', '普通')
export const SPLIT_BILL_TYPE = new BillType(2, 'Split', '拆单')
export const MERGE_BILL_TYPE = new BillType(3, 'Merge', '并单')

export const BILL_TYPES = new Set([NORMAL_BILL_TYPE, SPLIT_BILL_TYPE, MERGE_BILL_TYPE])
export const BILL_TYPE_VALUES = [
  { serialNumber: 1, code: 'Normal', name: 'Normal', localName: '普通' },
  { serialNumber: 2, code: 'Split', name: 'Split', localName: '拆单' },
  { serialNumber: 3, code: 'Merge', name: 'Merge', localName: '并单' }
]
/**
 *  return null:没找到.
 */
export function getBillTypeByCode(code) {
  return Model.getObjByCode(code, BILL_TYPES)
}
